import { useEffect } from "react";

import { AppLoaderOptions, useAppLoading } from "~/components/loading/hooks";

export interface AppLoadingProps extends AppLoaderOptions {
  readonly loading?: boolean;
}

/**
 * A component that will cause the loading indicator in the top level of the application content to appear when 'loading' is provided as
 * 'true'.
 */
export const AppLoading = ({ loading, ...props }: AppLoadingProps) => {
  const [setLoading] = useAppLoading(props);

  useEffect(() => {
    setLoading(loading === undefined ? false : loading);
  }, [loading, setLoading]);

  return <></>;
};
